import src from "IMAGE";
export default { src, width: 159, height: 39, blurWidth: 0, blurHeight: 0};
